export default class ContactForm {
  constructor() {
    if (!this.setVars()) return;
    this.setEvents();
  }

  setVars() {
    this.contactForm = document.querySelector('.wpcf7');
    if (!this.contactForm) this.contactForm = document.querySelector('.comment-form');
    if (!this.contactForm) return;

     
    this.contactFields = this.contactForm.querySelectorAll('input[type="text"], input[type="email"], textarea');
    if (!this.contactFields.length) return;

    return true;
  }

  setEvents() {
    this.contactFields.forEach((singleField) => {
      if (singleField.value) singleField.closest('label').classList.add('active');

      singleField.addEventListener('input', this.inputTitle.bind(this));
    });
  }

   
  inputTitle(event) {
    const closestLabel = event.target.closest('label');

    if (event.target.value && !closestLabel.classList.contains('active')) {
      closestLabel.classList.add('active');
    } else if (!event.target.value && closestLabel.classList.contains('active')) {
      closestLabel.classList.remove('active');
    }
  }
}
